import { useCallback, useEffect, useState } from 'react';
import { useRoutes } from 'react-router-dom';
import { useUser } from '../../contexts/user';
import { routes } from '../../router';
import { getNotifications, getUserProfile, preStartCheck } from '../../core';
// import Cookies from 'js-cookie';
import { SplashPage } from '../basic/splash';
// import { ping } from '../../core/api';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const RouteHandler = (props: { setHideNotification: (state: boolean) => void }) => {
  const { setUser, userTrigger } = useUser();
  // const [isPing] = useState(true);
  const [loading, setLoading] = useState(true);
  const [isPing, setIsPing] = useState(false);

  const handleNotifications = useCallback(async () => {
    try {
      const { status, data } = await getNotifications();
      if (status === 200) {
        const notifs = localStorage.getItem('notifications');
        if (notifs) {
          const notifss = JSON.parse(notifs);
          if (notifss[0].id === data[0].id) {
            //
          } else {
            localStorage.setItem('notifications', JSON.stringify(data));
            props.setHideNotification(false);
          }
        } else {
          localStorage.setItem('notifications', JSON.stringify(data));
          props.setHideNotification(false);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [props]);

  const handleUser = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const { status, data } = await getUserProfile();
        if (status === 200) {
          setUser({ ...data, isLoggedIn: true });
        } else {
          setUser({ isLoggedIn: false });
        }
      } catch (e) {
        console.log(e);
        setUser({ isLoggedIn: false });
      }
    } else {
      setUser({ isLoggedIn: false });
    }
  }, []);

  const handlePreStart = useCallback(async () => {
    let uId = localStorage.getItem('uId');

    if (!uId) {
      const fp = await FingerprintJS.load();
      const { visitorId } = await fp.get();
      uId = visitorId;

      localStorage.setItem('uId', visitorId);
    }
    try {
      const { status, data } = await preStartCheck(uId);
      if (status === 200) {
        setIsPing(true);
        console.log(data);
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setIsPing(false);
      await handlePreStart();
      await handleUser();
      await handleNotifications();
      setLoading(false);
    })();
  }, [userTrigger]);

  const routing = useRoutes(routes(!!isPing));

  if (loading) return <SplashPage connected={true} />;

  return routing;
};

export default RouteHandler;
